var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{class:_vm.controlFieldClass,attrs:{"id":_vm.control.uniqueId,"type":"number","inputmode":"numeric","pattern":"[0-9]*","name":_vm.control.name,"placeholder":_vm.localizedPlaceholder},domProps:{"value":_vm.number},on:{"input":function($event){return _vm.convertToNumber($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }